import type { ParticipantNote } from '@seen/core/models/participantNote'
import type { VisitNote } from '@seen/core/models/visitNote'
import { resolveId } from '@seen/core/references'
import { useErrorToast } from '#src/hooks/useErrorToast.ts'

export function useVisitNoteHref(
  visitNote: VisitNote | ParticipantNote | null | undefined
): string | undefined {
  const participantId = visitNote?.subject
    ? resolveId(visitNote.subject)
    : undefined

  useErrorToast(
    visitNote && !participantId && `Visit note ${visitNote.id} has no subject`
  )

  if (!visitNote) {
    return undefined
  }

  return `/Patient/${participantId}/visit-notes/${visitNote.id}`
}
